<div #filling></div>

<nav #navbar id="navbar" class="navbar-rm navbar navbar-expand-lg">
    <div class="container">
        <!-- Marca -->
        <a id="subheader-logo" class="navbar-brand" [routerLink]="'/amena'" style="padding-top: .563rem; padding-bottom: .563rem;">
            <img src="./assets/img/logo-amena.svg" class="img-fluid icon-nav2" width="85">
        </a>
        <div class="navbar-nav me-auto">
            <!-- Proceso de contratación -->
            <span class="navbar-text contratacion">
            {{title}}
          </span>
        </div>
        <div id="carrito" class="my-2 my-lg-0" *ngIf="this.router.url === '/amena/solo_movil' || this.router.url === '/amena/convergente'">
          <span class="carrito" (click)="openCart()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-shopping-cart icon-cart">
                  <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
            <div [ngClass]="{'item':true, 'animated shake delay-5s':total > 0}">
             <!-- Total de carrito -->
             <span id="importe_carrito" class="badges badge-pill badge-light carrito-result" (click)="openCart()"><b>{{ total | currency:'EUR':''}}<span class="eu"> €</span></b></span>
            </div>
          </span>
            <a (click)="cancel()" class="btn btn-white-outline btn-sm">Volver al inicio</a>
        </div>

        <div *ngIf="this.router.url.includes('/amena/listado')" class="my-2 my-lg-0">
            <a routerLink="/" class="btn btn-white-outline btn-sm">Volver al inicio</a>
        </div>

        <div *ngIf="this.router.url.includes('/amena/order')" class="my-2 my-lg-0">
            <a routerLink="/amena/listado" class="btn btn-white-outline btn-sm">Volver al listado</a>
        </div>
    </div>
</nav>
